/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./user.avatar";
import * as i2 from "../../services/me.service";
var styles_UserAvatar = [];
var RenderType_UserAvatar = i0.ɵcrt({ encapsulation: 2, styles: styles_UserAvatar, data: {} });
export { RenderType_UserAvatar as RenderType_UserAvatar };
export function View_UserAvatar_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "img", [["class", "img-circle"]], [[8, "src", 4], [8, "alt", 0], [8, "width", 0], [8, "height", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.avatarSrc; var currVal_1 = _co.avatarAlt; var currVal_2 = _co.size; var currVal_3 = _co.size; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3); }); }
export function View_UserAvatar_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "user-avatar", [], null, null, null, View_UserAvatar_0, RenderType_UserAvatar)), i0.ɵdid(1, 114688, null, 0, i1.UserAvatar, [i2.MeService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var UserAvatarNgFactory = i0.ɵccf("user-avatar", i1.UserAvatar, View_UserAvatar_Host_0, { size: "size" }, {}, []);
export { UserAvatarNgFactory as UserAvatarNgFactory };
